import { DateString } from "../../../../../lib/api/models";
import DateInput from "../../../../common/inputs/DateInput";
import { DateInputProps } from "../../../../common/inputs/DateInput/DateInput";
import {
  StyledInputLabelProps,
  StyledInputValidationProps,
} from "../../../../common/inputs/StyledInput/StyledInput";
import styles from "./PrintDateInput.module.css";

type Props = Omit<DateInputProps, "onChange"> &
  StyledInputLabelProps &
  StyledInputValidationProps & {
    value: DateString;
    onChange: (v: DateString) => void;
  };

export default function PrintDateInput({ onChange, ...props }: Props) {
  return (
    <DateInput
      {...props}
      className={props.className}
      labelClassName={styles.inputLabel}
      inputClassName={styles.input}
      onChangeDate={onChange}
    />
  );
}
